import React, { useState } from 'react';
import { Layout as AntLayout, Menu } from 'antd';
import {
  DashboardOutlined,
  ShoppingCartOutlined,
  TagsOutlined,
  AppstoreOutlined,
  BarsOutlined,
  ShoppingOutlined,
  TeamOutlined,
  DatabaseOutlined,
  UserOutlined,
  SettingOutlined,
  BankOutlined
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { roleUtils } from '../../types/auth.types';
import Header from './Header';
import './Layout.css';
import '../../styles/variables.css';

const { Sider, Content } = AntLayout;

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { auth } = useAuth();
  
  const userRoles = auth.user?.roles || [];
  const isAdmin = roleUtils.hasRole(userRoles, 'ROLE_ADMIN');
  const isManager = roleUtils.hasRole(userRoles, 'ROLE_MANAGER');
  
  const menuItems = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
    },
    {
      key: '/pos',
      icon: <ShoppingCartOutlined />,
      label: 'Point of Sale',
    },
    {
      key: '/products',
      icon: <TagsOutlined />,
      label: 'Products',
    },
    {
      key: '/categories',
      icon: <AppstoreOutlined />,
      label: 'Categories',
    },
    {
      key: '/brands',
      icon: <BarsOutlined />,
      label: 'Brands',
    },
    {
      key: '/orders',
      icon: <ShoppingOutlined />,
      label: 'Orders',
    },
    {
      key: '/promotions',
      icon: <TagsOutlined />,
      label: 'Promotions',
    },
    {
      key: '/customers',
      icon: <TeamOutlined />,
      label: 'Customers',
    },
    ...(isAdmin || isManager ? [
      {
        key: '/inventory',
        icon: <DatabaseOutlined />,
        label: 'Inventory',
      },
      {
        key: '/suppliers',
        icon: <BankOutlined />,
        label: 'Suppliers',
      },
    ] : []),
    ...(isAdmin ? [
      {
        key: '/users',
        icon: <UserOutlined />,
        label: 'Users',
      },
    ] : []),
    {
      key: '/settings',
      icon: <SettingOutlined />,
      label: 'Settings',
    },
  ];
  
  const onMenuClick = (e: { key: string }) => {
    navigate(e.key);
  };
  
  const toggleSider = () => {
    setCollapsed(!collapsed);
  };
  
  return (
    <AntLayout className="app-container">
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        className="app-sidebar"
      >
        <div className="app-logo">
          <div className="brand">
            <span className="brand-icon">💳</span>
            {!collapsed && <span className="brand-text">POS System</span>}
          </div>
          {/* Sidebar toggle removed to avoid duplicate with header button */}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={onMenuClick}
        />
      </Sider>
      
      <AntLayout>
        <Header collapsed={collapsed} toggle={toggleSider} />
        <Content className={`app-content ${collapsed ? 'collapsed' : ''}`}>
          {children}
        </Content>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout; 